<template>
  <div id="register-background" class="li-lo-background" ref="registerComponent">  
    <router-link to="/apply" class="logo">
      <div style="width: 200px; float: left;">
          <svg width="100%" height="100%" viewBox="0 0 441 49" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;">
              <g transform="matrix(1,0,0,1,-217.867,-443.326)">
                  <g transform="matrix(4.97792,0,0,5.01892,-1101.74,-1983.69)">
                      <text x="264.983px" y="492.946px" style="font-family:'Comfortaa-Bold', 'Comfortaa';font-weight:700;font-size:12px;fill:white;">W<tspan x="274.919px " y="492.946px ">a</tspan>termarks</text>
                      <text x="339.647px" y="492.946px" style="font-family:'Comfortaa-Bold', 'Comfortaa';font-weight:700;font-size:12px;fill:rgb(255,191,0);">.io</text>
                  </g>
              </g>
          </svg>
      </div>
    </router-link>  
    <router-link to="/apply" class="exit-button uk-modal-close-default"><i class="material-icons" style="font-size: 50px;">close</i></router-link>
    <div class="uk-container">
      <div class="uk-grid uk-flex-center">
        <!-- Register Form -->
        <register-form></register-form>       
        <!-- Register Features -->
        <div v-if="registerSource === 'default'" class="uk-padding-large-left uk-margin-large-top" style="z-index: 40;">
          <div class="features-box">
            <div class="features-box-content">
              <legend class="uk-legend uk-text-center">Account Features</legend>
              <hr>
              <div class="uk-grid-collapse uk-grid uk-margin-top" uk-grid="">
                  <div class="uk-width-auto uk-first-column"><i class="material-icons wm-green2">check_circle_outline</i></div>
                  <div class="uk-width-expand uk-margin-small-left">
                    <b>Quick and free sign-up</b>
                    <br><span class="uk-text-small">Enter your email address to create an account</span>
                  </div>
              </div> 
              <div class="uk-grid-collapse uk-grid uk-margin-top" uk-grid="">
                  <div class="uk-width-auto uk-first-column"><i class="material-icons wm-green2">check_circle_outline</i></div>
                  <div class="uk-width-expand uk-margin-small-left">
                    <b>Save watermarks</b>
                    <br><span class="uk-text-small">Watermarks will be saved to the cloud for future use</span>
                  </div>
              </div> 
              <div class="uk-grid-collapse uk-grid uk-margin-top" uk-grid="">
                  <div class="uk-width-auto uk-first-column"><i class="material-icons wm-green2">check_circle_outline</i></div>
                  <div class="uk-width-expand uk-margin-small-left">
                    <b>Resize Photos</b>
                    <br><span class="uk-text-small">Resize 100's of photos at once, all online</span>
                  </div>
              </div> 
              <hr>                                                    
            </div>
          </div> 
        </div>        
      </div>       
    </div>
    <!-- Floating Rotating Squares -->
    <ul class="bg-bubbles">
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>   
  </div>
</template>

<script>
import Vue from 'vue'
import RegisterForm from './RegisterForm.vue'

  export default {
    name: 'Homepage',
    props:{
      registerSource: {
        type: String,
        default: 'default'
      }    
    },
    components: {
      'register-form': RegisterForm, 
    },    
    data () {
      return {
      }
    }
  }
</script>

<style scoped>

.uk-container {
  padding-top: 110px;
}

.logo {
  position:absolute;
  left:60px;
  top:60px;
  z-index: 222;
}

.exit-button {
  position:absolute;
  right:50px;
  top:50px;
  z-index: 222;
}

.features-box {
  border: 1px solid gray;
  border-radius: 5px;
  width: 400px;
  background: white;
  margin-bottom: 40px;
}

.features-box-content {
  padding: 40px;
  box-shadow: 0 2px 10px 0 rgba(0,0,0,.2);
  border-radius: 5px !important;
  z-index: 1550 !important;
  background-image: linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%);  
}

.li-lo-background {
  height: 100%;
  /* background image */
  background: url('../../../static/backgrounds/login/wave_blue_background.png') no-repeat center center fixed; 
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;  
  /* fill entire screen with no scroll */
	position: absolute;
	top: 50%;
	left: 0;
	width: 100%;
	height: 100vh;
	margin-top: -50vh;
	overflow: hidden;
}

.uk-input {
  border-radius: 3px !important;
}

/* Square Floating */
.bg-bubbles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.bg-bubbles li {
  position: absolute;
  list-style: none;
  display: block;
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.15);
  bottom: -160px;
  -webkit-animation: square 25s infinite;
  animation: square 25s infinite;
  transition-timing-function: linear;
}
.bg-bubbles li:nth-child(1) {
  left: 10%;
}
.bg-bubbles li:nth-child(2) {
  left: 20%;
  width: 80px;
  height: 80px;
  -webkit-animation-delay: 2s;
          animation-delay: 2s;
  -webkit-animation-duration: 17s;
          animation-duration: 17s;
}
.bg-bubbles li:nth-child(3) {
  left: 25%;
  -webkit-animation-delay: 4s;
          animation-delay: 4s;
}
.bg-bubbles li:nth-child(4) {
  left: 40%;
  width: 60px;
  height: 60px;
  -webkit-animation-duration: 22s;
          animation-duration: 22s;
  background-color: rgba(255, 255, 255, 0.25);
}
.bg-bubbles li:nth-child(5) {
  left: 70%;
}
.bg-bubbles li:nth-child(6) {
  left: 80%;
  width: 120px;
  height: 120px;
  -webkit-animation-delay: 3s;
          animation-delay: 3s;
  background-color: rgba(255, 255, 255, 0.2);
}
.bg-bubbles li:nth-child(7) {
  left: 32%;
  width: 160px;
  height: 160px;
  -webkit-animation-delay: 7s;
          animation-delay: 7s;
}
.bg-bubbles li:nth-child(8) {
  left: 55%;
  width: 20px;
  height: 20px;
  -webkit-animation-delay: 0s;
          animation-delay: 0s;
  -webkit-animation-duration: 40s;
          animation-duration: 40s;
}
.bg-bubbles li:nth-child(9) {
  left: 25%;
  width: 10px;
  height: 10px;
  -webkit-animation-delay: 2s;
          animation-delay: 2s;
  -webkit-animation-duration: 40s;
          animation-duration: 40s;
  background-color: rgba(255, 255, 255, 0.3);
}
.bg-bubbles li:nth-child(10) {
  left: 90%;
  width: 160px;
  height: 160px;
  -webkit-animation-delay: 11s;
          animation-delay: 11s;
}
@-webkit-keyframes square {
  0% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(-700px) rotate(600deg);
            transform: translateY(-700px) rotate(600deg);
  }
}
@keyframes square {
  0% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(-700px) rotate(600deg);
            transform: translateY(-700px) rotate(600deg);
  }
}

</style>